import Configurations from '@/views/Configurations/Index.vue'

export default [
    {
        path: '/configurations',
        name: 'configurations',
        component: Configurations,
        meta: {
            title: 'configurations.root.pageTitle',
            menuRendered: true,
            menuTitle: 'configurations.root.menuTitle',
            icon: 'mdi-cog'
        },
        children: [
            {
                path: '/configurations/materials',
                name: 'configurationsMaterials',
                component: () => import('@/views/Configurations/Materials/Index.vue'),
                redirect: { name: 'configurationsMaterialsPapers' },
                meta: {
                    title: 'configurations.materials.rootTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.materials.menuTitle',
                    requiresAuth: true,
                    permission: 'dictionaries'
                },
                children: [
                    {
                        path: '/configurations/materials/papers',
                        name: 'configurationsMaterialsPapers',
                        component: () => import('@/views/Configurations/Materials/pages/Papers/Index.vue'),
                        meta: {
                            title: 'configurations.materials.pages.papers.sections.title',
                            requiresAuth: true,
                            permission: 'dictionaries'
                        }
                    },
                    {
                        path: '/configurations/materials/paper-groups',
                        name: 'configurationsMaterialsPaperGroups',
                        component: () => import('@/views/Configurations/Materials/pages/PaperGroups/Index.vue'),
                        meta: {
                            title: 'configurations.materials.pages.paperGroups.sections.title',
                            requiresAuth: true,
                            permission: 'dictionaries'
                        }
                    },
                    {
                        path: '/configurations/materials/other-materials',
                        name: 'configurationsMaterialsOtherMaterials',
                        component: () => import('@/views/Configurations/Materials/pages/OtherMaterials/Index.vue'),
                        meta: {
                            title: 'configurations.materials.pages.otherMaterials.sections.title',
                            requiresAuth: true,
                            permission: 'dictionaries'
                        }
                    }
                ]
            },
            {
                path: '/configurations/production-processes',
                name: 'configurationsProductionProcesses',
                component: () => import('@/views/Configurations/ProductionProcesses/Index.vue'),
                meta: {
                    title: 'configurations.productionProcesses.pages.main.sections.title',
                    menuRendered: true,
                    menuTitle: 'configurations.productionProcesses.pages.main.sections.title',
                    requiresAuth: true,
                    permission: 'production_processes'
                }
            },
            {
                path: '/configurations/machines',
                name: 'configurationsMachines',
                component: () => import('@/views/Configurations/Machines/Index.vue'),
                meta: {
                    title: 'configurations.machines.pageTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.machines.menuTitle',
                    requiresAuth: true,
                    permission: 'machines'
                }
            },
            {
                path: '/configurations/production-sites',
                name: 'configurationsProductionSites',
                component: () => import('@/views/Configurations/ProductionSites/Index.vue'),
                meta: {
                    title: 'configurations.productionSites.pages.main.sections.title',
                    menuRendered: true,
                    menuTitle: 'configurations.productionSites.pages.main.sections.title',
                    requiresAuth: true,
                    permission: 'production_sites'
                }
            },
            {
                path: '/configurations/products',
                name: 'configurationsProducts',
                component: () => import('@/views/Configurations/Products/Index.vue'),
                meta: {
                    title: 'configurations.products.menuTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.products.menuTitle',
                    requiresAuth: true,
                    permission: 'products'
                }
            },
            {
                path: '/configurations/products/:id',
                name: 'configurationsProductsProduct',
                component: () => import('@/views/Configurations/Products/Product/Index.vue'),
                props: true,
                meta: {
                    title: 'configurations.products.productPageTitle',
                    requiresAuth: true,
                    permission: 'products'
                }
            },
            {
                path: '/configurations/tools',
                name: 'configurationsTools',
                component: () => import('@/views/Configurations/Tools/Index.vue'),
                redirect: { name: 'configurationsToolsDieCutters' },
                meta: {
                    title: 'configurations.tools.pageTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.tools.menuTitle',
                    requiresAuth: true,
                    permission: 'die_cutters'
                },
                children: [
                    {
                        path: '/configurations/tools/die-cutters',
                        name: 'configurationsToolsDieCutters',
                        component: () => import('@/views/Configurations/Tools/pages/DieCutters/Index.vue'),
                        meta: {
                            title: 'configurations.tools.dieCutters.pages.main.sections.title',
                            requiresAuth: true,
                            permission: 'die_cutters_read'
                        }
                    }
                ]
            },
            {
                path: '/configurations/rubber-registry',
                name: 'configurationsRubberRegistry',
                component: () => import('@/views/Configurations/RubberRegistry/Index.vue'),
                meta: {
                    title: 'configurations.rubberRegistry.pageTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.rubberRegistry.menuTitle',
                    requiresAuth: true,
                    permission: 'rubbers'
                }
            },
            {
                path: '/configurations/calculations-costs',
                name: 'configurationsCalculationsCosts',
                component: () => import('@/views/Configurations/CalculationCosts/Index.vue'),
                redirect: { name: 'configurationsCalculationsCostsNettoMarkUp' },
                meta: {
                    title: 'configurations.calculationCosts.pageTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.calculationCosts.menuTitle',
                    requiresAuth: true,
                    permission: 'finances'
                },
                children: [
                    {
                        path: '/configurations/calculations-costs/netto-mark-up',
                        name: 'configurationsCalculationsCostsNettoMarkUp',
                        component: () => import('@/views/Configurations/CalculationCosts/pages/NettoMarkUp/Index.vue'),
                        meta: {
                            title: 'configurations.calculationCosts.pages.nettoMarkUp.pageTitle',
                            requiresAuth: true,
                            permission: 'finances_read'
                        }
                    },
                    {
                        path: '/configurations/calculations-costs/product-group-factors',
                        name: 'configurationsCalculationsCostsProductGroupFactors',
                        component: () => import('@/views/Configurations/CalculationCosts/pages/ProductGroupFactors/Index.vue'),
                        meta: {
                            title: 'configurations.calculationCosts.pages.productGroupFactors.pageTitle',
                            requiresAuth: true,
                            permission: 'finances_read'
                        }
                    },
                    {
                        path: '/configurations/calculations-costs/traders-mark-up',
                        name: 'configurationsCalculationsCostsTradersMarkUp',
                        component: () => import('@/views/Configurations/CalculationCosts/pages/TradersMarkUp/Index.vue'),
                        meta: {
                            title: 'configurations.calculationCosts.pages.tradersMarkUp.pageTitle',
                            requiresAuth: true,
                            permission: 'finances_read'
                        }
                    }
                ]
            },
            {
                path: '/configurations/manual-works',
                name: 'configurationsManualWorks',
                component: () => import('@/views/Configurations/ManualWorks/Index.vue'),
                meta: {
                    title: 'configurations.manualWorks.pageTitle',
                    menuRendered: true,
                    menuTitle: 'configurations.manualWorks.menuTitle',
                    requiresAuth: true,
                    permission: 'manual_works'
                }
            }
        ]
    }
]
